import { useState } from 'react';

import { Col, Layout, Row, Space } from 'antd';
import Card from 'antd/lib/card/Card';
import { useSelector } from 'react-redux';
import { UserDto } from 'src/dtos';
import { MButton, MTypography } from 'src/lib';
import { Color } from 'src/styles';

import { MyAccountLayout } from '../../lib/Layout/MyAccountLayout/MyAccountLayout';
import { MyAccountSidebarOtherMenuItemKey } from '../../lib/Layout/MyAccountLayout/MyAccountSidebar';

import { UpdateEmailModal } from './UpdateEmailModal';
import { UpdatePhoneNumberModal } from './UpdatePhoneNumberModal';
import * as Styles from './UserSettings.styles';

export const UserSettings = () => {
  const userInfo: UserDto = useSelector((state: any) => state.user.authenticated.data);

  const [isUpdateEmailModalVisible, setIsUpdateEmailModalVisible] = useState<boolean>(false);
  const [isUpdatePhoneNumberModalVisible, setIsUpdatePhoneNumberModalVisible] = useState<boolean>(false);

  return (
    <MyAccountLayout sidebarMenuItemKey={MyAccountSidebarOtherMenuItemKey.UserSettings}>
      <Layout className={Styles.screen}>
        <Row gutter={[2, 32]}>
          <Col span={24}>
            <MTypography variant='h4' color={Color.Brand6}>
              Change Email Address
            </MTypography>
            <Card className={Styles.cardWrapper}>
              <Row gutter={24}>
                <Col flex={7}>
                  <Space direction='vertical' size={0}>
                    <MTypography variant='body1' weight='semibold' color={Color.Gray8}>
                      Email address
                    </MTypography>
                    <MTypography variant='body1' weight='normal' color={Color.Gray7}>
                      {userInfo.email}
                    </MTypography>
                  </Space>
                </Col>
                <Col flex={3} className={Styles.justifyRight}>
                  <MButton onClick={() => setIsUpdateEmailModalVisible(true)}>Change Email</MButton>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col span={24}>
            <MTypography variant='h4' color={Color.Brand6}>
              Change Phone Number
            </MTypography>
            <Card className={Styles.cardWrapper}>
              <Row gutter={24}>
                <Col flex={7}>
                  <Space direction='vertical' size={0}>
                    <MTypography variant='body1' weight='semibold' color={Color.Gray8}>
                      Phone number
                    </MTypography>
                    <MTypography variant='body1' weight='normal' color={Color.Gray7}>
                      {userInfo.phoneNumber}
                    </MTypography>
                  </Space>
                </Col>
                <Col flex={3} className={Styles.justifyRight}>
                  <MButton
                    className={Styles.changePhoneNumberButton}
                    onClick={() => setIsUpdatePhoneNumberModalVisible(true)}>
                    Change Phone Number
                  </MButton>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <UpdateEmailModal isVisible={isUpdateEmailModalVisible} onClose={() => setIsUpdateEmailModalVisible(false)} />

        <UpdatePhoneNumberModal
          isVisible={isUpdatePhoneNumberModalVisible}
          onClose={() => setIsUpdatePhoneNumberModalVisible(false)}
        />
      </Layout>
    </MyAccountLayout>
  );
};
